function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", null, React.createElement("title", null, "Version Icon"), React.createElement("circle", {
  stroke: "null",
  id: "svg_1",
  fill: "#6E7583",
  r: 11.94737,
  cy: 11.94737,
  cx: 11.99123
}), React.createElement("path", {
  stroke: "null",
  id: "svg_2",
  fill: "white",
  d: "m6.80819,16l-2.4875,-6.92031l1.46881,0l1.33259,4.02329c0.22901,0.67576 0.3672,1.22222 0.41459,1.63935l0.04737,0c0.03554,-0.30034 0.17374,-0.84679 0.41459,-1.63935l1.33259,-4.02329l1.48065,0l-2.49935,6.92031l-1.50435,0zm10.10376,-5.44364l-0.32575,1.777l1.59908,0l0,1.0512l-1.7945,0l-0.47386,2.61545l-1.05419,0l0.47386,-2.61545l-1.46889,0l-0.47378,2.61545l-1.03054,0l0.45013,-2.61545l-1.48065,0l0,-1.0512l1.6761,0l0.33759,-1.777l-1.56358,0l0,-1.05118l1.73534,0l0.47379,-2.64049l1.06605,0l-0.47373,2.64049l1.49247,0l0.47373,-2.64049l1.03061,0l-0.47386,2.64049l1.49261,0l0,1.05118l-1.68803,0zm-2.86055,1.777l1.48061,0l0.33761,-1.777l-1.48075,0l-0.33747,1.777z"
}));
var SvgVersionIcon = function SvgVersionIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVersionIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/version-icon.fbb63f02.svg";
export { ForwardRef as ReactComponent };